'use client';

import { Footer as CloudUIFooter, Stack, Typography } from '@unity/cloud-ui';
import { NestedKeyOf, useTranslations } from 'next-intl';
import onetrust from '@/lib/onetrust';
import { NavigationLink } from '@/components/navigation-link';

export const LINKS: { labelKey: NestedKeyOf<IntlMessages>; href: string }[] = [
  {
    labelKey: 'footer:links:legal',
    href: 'https://unity.com/legal',
  },
  {
    labelKey: 'footer:links:privacy-policy',
    href: 'https://unity.com/legal/privacy-policy',
  },
  {
    labelKey: 'footer:links:cookies',
    href: 'https://unity.com/legal/cookie-policy',
  },
  {
    labelKey: 'footer:links:personal-info',
    href: 'https://unity.com/legal/do-not-sell-my-personal-information',
  },
];

export const Footer = () => {
  const t = useTranslations();

  const handleCookieSettingClicked = (e) => {
    e.preventDefault();
    onetrust.openPreferenceCenter();
  };

  return (
    <CloudUIFooter
      links={
        <Stack gap={2} direction="column">
          <Typography variant="subtitle2" color="textSecondary" component="span">
            {t('footer:copyright-statement', {
              date: new Date().getFullYear().toString(),
            })}
          </Typography>
          <Stack direction="row" gap={2} rowGap={0.5} flexWrap={{ xs: 'wrap', s: 'nowrap' }}>
            {Object.entries(LINKS).map(([key, { href, labelKey }]) => (
              <Typography key={key} variant="subtitle2" component="span">
                <NavigationLink href={href} flexShrink={0} underline="hover" color="textPrimary">
                  {t(labelKey)}
                </NavigationLink>
              </Typography>
            ))}
            <NavigationLink href="#" onClick={handleCookieSettingClicked} underline="hover" color="textPrimary">
              <Typography variant="subtitle2" component="span">
                {t('footer:privacy:cookie-settings')}
              </Typography>
            </NavigationLink>
          </Stack>
          <Typography variant="subtitle2" component="p" color="textSecondary">
            {t.rich('footer:unity-trademark-statement', {
              link: (chunks) => (
                <NavigationLink href="https://unity.com/legal/trademarks" external>
                  {chunks}
                </NavigationLink>
              ),
            })}
          </Typography>
        </Stack>
      }
    />
  );
};
